export const SORTABLE_COLUMNS = {
    "Shipment Number": "shipmentNumber",
    "Office Code": "officeCode",
    "Status": "status",
    // Sorted server-side after claim-summary enrichment (claimed first, then status).
    "Claims": "hasClaims",
    "PO Number": "poNumber",
    "Sales Order": "salesOrderNumber",
    "Booking Number": "bookingNumber",
    "Planned Pickup Date": "pickupDate",
    "Scheduled Pickup Time": "pickupDate",
    "Planned Delivery Date": "deliveryDate",
    "Scheduled Delivery Time": "deliveryDate",
    "Ready for Pickup Date Time": "readyForPickupDateTime",
    "Created Date": "createdDate",
    "Updated Date": "updatedDate",
    "Total Charges": "totalCharge",
    "Carrier Name": "carrierName",
    // "Carrier SCAC Code" is intentionally absent: it lives on the carrier party
    // relation, and the search query is SELECT DISTINCT, which MySQL will not let
    // us ORDER BY a non-selected joined column. Sorting it returned a 500; leaving
    // it out keeps the header non-sortable instead of silently sorting by pickup date.
    "PRO Number": "proNumber",
    "Equipment Number": "equipmentNumber",
    "Mode": "movementType",
    "Payment Type": "paymentMethod",
    "Origin": "portOfOrigin",
    "Destination": "portOfDestination",
    "Destination Country": "destinationCountry",
    "Destination State": "destinationState",
    "Destination City": "destinationCity",
    "Destination Zip": "destinationZipCode",
    "Is Invoiced": "isInvoiced",
    "Invoice Number": "invoiceNumber",
    "Invoice Status": "invoiceStatus",
    "Pickup Location Reason Name": "stopReasonName",
    "Actual Pickup Time": "actualGateIn",
    "Actual Delivery Time": "actualGateOut",
    "Pickup Appointment Time": "pickupAppointmentStartDate",
  };


export const FILTER_TABS = {
    ALL: "ALL",
    DT: "DROP_TRAILER",
    NOT_INVOICED: "NOT_INVOICED",
}